import { writable } from 'svelte/store';

// Store for chemistry table results that persists during browser session but clears on page refresh
// This is a module-level store that won't be reset when components are recreated
export const chemistryDataStore = writable(null);
